import { FC } from 'react';
import { Tr } from '@utils';
import { Button, ButtonProps, Divider, Stack, Typography } from '@mui/material';
import { VoltaageModalDialog, IVoltaageModalDialogProps } from '@components/common';

export interface IElectrificationWizardConfirmationDialogProps extends IVoltaageModalDialogProps {
	year?: number;
	disableChildrenTypography?: boolean;
	buttonProps?: Extendable<ButtonProps>;
	onAccept?: () => void;
}

export const ElectrificationWizardConfirmationDialog: FC<IElectrificationWizardConfirmationDialogProps> = ({
	year,
	buttonProps: { sx: buttonSx, ...buttonProps } = {},
	onAccept,
	...props
}) => {
	return (
		<VoltaageModalDialog
			title={<Tr.Portal path="dashboard.electrification-wizard-confirmation-title" />}
			dividers
			maxWidth="sm"
			{...props}
		>
			<Stack direction="column" alignItems="center" sx={{ padding: 3 }} spacing={3}>
				<Typography>
					<Tr.Portal path="dashboard.electrification-wizard-confirmation-content" options={{ year }} />
				</Typography>
				<Divider light sx={{ width: 1.0 }} />
				<Button
					variant="contained"
					color="primary"
					sx={{ marginX: 'auto !important', ...buttonSx }}
					onClick={onAccept}
					{...buttonProps}
				>
					<Tr.Portal path="confirm" />
				</Button>
			</Stack>
		</VoltaageModalDialog>
	);
};
